// extracted by mini-css-extract-plugin
export default {"PlaceholderDropdown":"T5woCe67"};